import { render, staticRenderFns } from "./PostedJobs.vue?vue&type=template&id=0fc70529&scoped=true"
import script from "./PostedJobs.vue?vue&type=script&lang=ts"
export * from "./PostedJobs.vue?vue&type=script&lang=ts"
import style0 from "./PostedJobs.vue?vue&type=style&index=0&id=0fc70529&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc70529",
  null
  
)

export default component.exports